'use strict';

angular.module('shiftTraderApp')
  .controller('WorkPeriodCtrl', function ($scope, $rootScope, AvailabilityRules, UserPermissionsService, workPeriod, me, NotesQueryManagementService) {
    $scope.me = me;
    $scope.workPeriod = workPeriod;
    $rootScope.$broadcast('setTopNavTitle', $scope.workPeriod.user.name + '\'s Shift');

    var theOrgId = $scope.workPeriod.organization_id || $scope.workPeriod.organization.id;

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null,
      managementIds: {
        today: NotesQueryManagementService.getUniqueId('notes-on-day'),
        position: NotesQueryManagementService.getUniqueId('notes-on-position'),
        workPeriod: NotesQueryManagementService.getUniqueId('notes-on-work-period')
      }
    };

    // Set the query based on the current date of the page
    NotesQueryManagementService.registerQueryChange($scope.state.managementIds.today, {
      obj: 'date',
      dates: {
        start: moment($scope.workPeriod.start_time),
        end: moment($scope.workPeriod.end_time)
      }
    });
    // Set the query based on the position of the workPeriod
    NotesQueryManagementService.registerQueryChange($scope.state.managementIds.position, {
      obj: 'Position',
      obj_id: $scope.workPeriod.position_id
    });
    // Set the query based on the workPeriod object
    NotesQueryManagementService.registerQueryChange($scope.state.managementIds.workPeriod, {
      obj: 'WorkPeriod',
      obj_id: $scope.workPeriod.id
    });

    var permissionsToLookUp = [
      'days_off.request_for_self',
      'days_off.request_for_other',
      'trades.view_mine',
      'trades.view_in_org',
      'trades.create_trade_for_self'
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, theOrgId)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();

        conditionallyGetDaysOff();

      });

    function processRawPermissions() {
      var myProf = $scope.me.id === $scope.workPeriod.user.id;
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        showRequestDayOff: myProf && rawPerm['days_off.request_for_self'],
        showCreateDayOff: !myProf && rawPerm['days_off.request_for_other'],
        hasPermissionToViewTrade: (myProf && rawPerm['trades.view_mine']) || (!myProf && rawPerm['trades.view_in_org']),
        showCreateTrade: myProf && rawPerm['trades.create_trade_for_self'],
        canDaysOffInOrg: rawPerm['availability_rules.view_in_org']
      };
    }


    function conditionallyGetDaysOff() {
      if ($scope.state.derivedPermissions.canDaysOffInOrg || $scope.me.id === $scope.workPeriod.user.id) {
        AvailabilityRules.getAll({
          user_id: $scope.workPeriod.user.id,
          type: 'daysoff',
          active: true,
          start_date: moment($scope.workPeriod.start_time).subtract(1, 'day').format(),
          end_date: moment($scope.workPeriod.end_time).add(1, 'day').format()
        }).then(function(rules) {
          $scope.overlappingDayOff = _.chain(rules).where(function(rule) {
            return rule.range_twix.overlaps($scope.workPeriod.range_twix) &&
                Math.abs(rule.range_twix.intersection($scope.workPeriod.range_twix).length('minutes')) > 0;
          }).first().value();
        }, function(response) {

        });
      }

    }

    $scope.layout = {
      name: 'layout-workperiod',
      data: {
        workPeriodId: $scope.workPeriod.id
      }
    }

  });
